/*
 * Copyright (c) Nexign, JSC, 2019-2022.
 */
/**
 *
 * @author Yakov Gushchin
 * @author Evgenij Tyan
 * @author Maxim Fedorov
 * @author Aleksandr Perkhunov
 * @author Ilya Babanov
 * @version 1.22.0
 * @since 1.0.1
 */
import type { SagaIterator } from 'redux-saga';
import { call, put, select } from 'redux-saga/effects';

import { requestSaga } from '@/main/sagas/requestSaga';
import { API_HOSTNAME, WIDGET_ACCOUNT_BALANCE, WIDGET_API } from '@modules/app/Api';
import { makeSelectLocalStorageSelectedAccount } from '@modules/storage/storageSelectors';

import {
    widgetPersonalAccountLoadDataError,
    widgetPersonalAccountLoadDataSuccessful,
} from './widgetPersonalAccountActions';

export function* widgetPersonalAccountLoadDataSaga(): SagaIterator {
    try {
        const selectedAccount = (yield select(makeSelectLocalStorageSelectedAccount())).id;
        const URL = API_HOSTNAME + WIDGET_API + `${WIDGET_ACCOUNT_BALANCE}/${selectedAccount}`;
        const response = yield call(requestSaga, URL, 'GET');

        if (response.accountNumber) {
            yield put(widgetPersonalAccountLoadDataSuccessful(response));
        } else {
            yield put(widgetPersonalAccountLoadDataError({ error: 'Error' }));
        }
    } catch (error: any) {
        yield put(widgetPersonalAccountLoadDataError({ error }));
    }
}
